import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import {
  RemoveDocumentTypeFromPermitType,
  RemoveDocumentTypeFromPermitTypeVariables,
} from "./__generated__/RemoveDocumentTypeFromPermitType";

const REMOVE_DOCUMENT_TYPE_FROM_PERMIT_TYPE = gql`
  mutation RemoveDocumentTypeFromPermitType($organizationId: String!, $permitTypeId: String!, $documentTypeId: String!) {
    removeDocumentTypeFromPermitType(
      input: { organizationId: $organizationId, permitTypeId: $permitTypeId, documentTypeId: $documentTypeId }
    ) {
      success
    }
  }
`;

export function useRemoveDocumentTypeFromPermitType() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    RemoveDocumentTypeFromPermitType,
    RemoveDocumentTypeFromPermitTypeVariables
  >(REMOVE_DOCUMENT_TYPE_FROM_PERMIT_TYPE, { errorPolicy: "all" });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
